import React, { useEffect } from 'react';
import UseGeneral from '../../hooks/useGeneral';
import Breadcrumb from '../../components/BreadCumbsLinks';
import CartLayout from '../../layouts/Cart/cart';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const { language } = UseGeneral();
  const breadCrumbsLinks = [
    { name: language != "ar" ? "Home" : "الصفحة الرئيسية", path: "/" },
    {
      name: language != "ar" ? "Cart" : "العربة",
      // path: "/Cart",
      active: true,
    },
  ];

  const localCartLength = useSelector((state) => state.offlineCart);
  const navigate = useNavigate()


  useEffect(()=>{

    const cartLenght = Array.isArray(localCartLength?.items)? localCartLength.items.length : 0

    if(+cartLenght <= 0)
    navigate('/',{replace:true})

  },[])




  return (
    <>
    <div className="categoriesLPage">
      <Breadcrumb links={breadCrumbsLinks} />
      <CartLayout />
    </div>
    </>
  );
};

export default Cart;
